/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Out_Order_LabelInputs */

const vi_pkl_out_order_label = /** @type {(inputs: Pkl_Out_Order_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng`)
};

/**

* @param {Pkl_Out_Order_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_out_order_label = /** @type {((inputs?: Pkl_Out_Order_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Out_Order_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_out_order_label(inputs)
});